import { z } from 'zod';
import { idSchema, isoDateTimeSchema } from '../../common.js';
/**
 * `feedback` (2026-11-03) — the "Ideas for AwwYeah? Tell Dan" box. Any member other than
 * the recipient (Dan) can send a short feature request from any screen; it is stored and
 * pushed to the recipient, who reads them in Settings. No Yjs doc of its own (a Postgres
 * table, like `mcp`/`push`), so it stays out of `MODULE_IDS`.
 */
export const FEATURE_REQUEST_MAX_LENGTH = 2000;
export const FEATURE_REQUEST_SCREEN_MAX_LENGTH = 300;
/** POST /api/feedback — the sender comes from the session cookie, never the body. */
export const featureRequestCreateSchema = z.object({
    text: z.string().trim().min(1).max(FEATURE_REQUEST_MAX_LENGTH),
    /** `location.pathname` (+ search) of the screen the idea was sent from. */
    screen: z.string().trim().max(FEATURE_REQUEST_SCREEN_MAX_LENGTH).optional(),
});
export const featureRequestSchema = z.object({
    id: idSchema,
    fromUserId: idSchema,
    /** The sender's display name at the time they sent it. */
    fromName: z.string().min(1).max(100),
    text: z.string().min(1).max(FEATURE_REQUEST_MAX_LENGTH),
    screen: z.string().max(FEATURE_REQUEST_SCREEN_MAX_LENGTH).nullable(),
    createdAt: isoDateTimeSchema,
});
export const featureRequestCreateResponseSchema = z.object({ request: featureRequestSchema });
/** GET /api/feedback — recipient only, newest first. */
export const featureRequestListResponseSchema = z.object({
    requests: z.array(featureRequestSchema),
});
/**
 * GET /api/feedback/status — what the footer link needs: whether this member may send
 * (everyone but the recipient and the bootstrap account), whether they ARE the recipient
 * (to show the inbox in Settings), and the recipient's first name for the link copy.
 */
export const feedbackStatusResponseSchema = z.object({
    canSend: z.boolean(),
    isRecipient: z.boolean(),
    recipientName: z.string().min(1).max(100).nullable(),
});
/** Accounts on this domain are operator spares (e.g. `setup@awwyeah.local`), not people. */
export const BOOTSTRAP_EMAIL_DOMAIN = '@awwyeah.local';
export function isBootstrapEmail(email) {
    return email.trim().toLowerCase().endsWith(BOOTSTRAP_EMAIL_DOMAIN);
}
/** Push body: the request itself, collapsed to one line and clipped to fit a banner. */
export function featureRequestPushBody(text, max = 180) {
    const oneLine = text.replace(/\s+/g, ' ').trim();
    return oneLine.length <= max ? oneLine : `${oneLine.slice(0, max - 1).trimEnd()}…`;
}
//# sourceMappingURL=index.js.map